import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface SessionExpiredBannerProps {
  onDismiss: () => void;
}

export const SessionExpiredBanner = ({ onDismiss }: SessionExpiredBannerProps) => {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  // Animate in on mount
  useEffect(() => {
    const t = requestAnimationFrame(() => setVisible(true));
    return () => cancelAnimationFrame(t);
  }, []);

  const handleDismiss = () => {
    setVisible(false);
    setTimeout(onDismiss, 300);
  };

  const handleLogin = () => {
    handleDismiss();
    setTimeout(() => navigate('/'), 300);
  };

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-[9999] flex justify-center pointer-events-none transition-all duration-300 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2'
      }`}
    >
      <div
        className="mt-3 mx-4 pointer-events-auto flex items-center gap-3 bg-white border border-amber-200 rounded-xl shadow-sm px-4 py-3 max-w-md w-full"
      >
        {/* Icon */}
        <div className="w-8 h-8 flex items-center justify-center shrink-0 bg-amber-50 rounded-lg">
          <i className="ri-time-line text-amber-500 text-base" />
        </div>

        {/* Text */}
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-gray-800 leading-snug">
            Sessão expirada
          </p>
          <p className="text-xs text-gray-500 leading-snug mt-0.5">
            Faça login novamente para continuar.
          </p>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-2 shrink-0">
          <button
            onClick={handleLogin}
            className="text-xs font-semibold text-amber-600 hover:text-amber-700 whitespace-nowrap cursor-pointer transition-colors"
          >
            Entrar
          </button>
          <button
            onClick={handleDismiss}
            className="w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer transition-colors rounded-md hover:bg-gray-100"
          >
            <i className="ri-close-line text-sm" />
          </button>
        </div>
      </div>
    </div>
  );
};